/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminWorkerJobProduct
 */
export interface AdminWorkerJobProduct {
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerJobProduct
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkerJobProduct
     */
    listingNumber: number;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerJobProduct
     */
    name: string;
}

export function AdminWorkerJobProductFromJSON(json: any): AdminWorkerJobProduct {
    return AdminWorkerJobProductFromJSONTyped(json, false);
}

export function AdminWorkerJobProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminWorkerJobProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'listingNumber': json['listingNumber'],
        'name': json['name'],
    };
}

export function AdminWorkerJobProductToJSON(value?: AdminWorkerJobProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'listingNumber': value.listingNumber,
        'name': value.name,
    };
}

